var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLavenderSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 597"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 118",
    cx: 40.1228,
    cy: 39.4118,
    r: 39.4118,
    fill: "#F5F4FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 595"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 115",
    cx: 39.8017,
    cy: 39.477,
    r: 22.9006,
    fill: "#ECEAFF",
    stroke: "#D9D5FF",
    strokeWidth: 1.33337
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 116",
    cx: 39.7986,
    cy: 39.4769,
    r: 16.1671,
    fill: "#FFFEFF",
    stroke: "#D9D5FF",
    strokeWidth: 1.33337
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M39.7963 27.1014C39.7963 26.8542 39.5957 26.653 39.3487 26.6616C36.2558 26.7696 33.3002 27.9932 31.0334 30.1149C28.7665 32.2365 27.3502 35.1048 27.0381 38.1837C27.0131 38.4297 27.2007 38.6431 27.4473 38.6594C27.694 38.6758 27.9063 38.4888 27.9319 38.243C28.2286 35.3907 29.5441 32.7349 31.6451 30.7685C33.7461 28.8021 36.4831 27.6649 39.3487 27.5574C39.5957 27.5481 39.7963 27.3486 39.7963 27.1014Z",
    fill: "#9F95FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 594"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 389",
    x: 57.5845,
    y: 64.4678,
    width: 7.92262,
    height: 23.2976,
    rx: 3.96131,
    transform: "rotate(-45 57.5845 64.4678)",
    fill: "#F5F4FF",
    stroke: "#D9D5FF",
    strokeWidth: 1.33337
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 390",
    x: 65.8633,
    y: 66.3203,
    width: 1.06985,
    height: 8.97042,
    rx: 0.534926,
    transform: "rotate(-45 65.8633 66.3203)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 391",
    x: 56.9688,
    y: 59.0293,
    width: 1.09821,
    height: 4.39284,
    transform: "rotate(-45 56.9688 59.0293)",
    fill: "#D9D5FF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 392",
    x: 68.6172,
    y: 36.7114,
    width: 10.9821,
    height: 1.09821,
    rx: 0.549105,
    fill: "#9F95FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 395",
    x: 0.710938,
    y: 45.7974,
    width: 10.9821,
    height: 1.09821,
    rx: 0.549105,
    fill: "#9F95FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 393",
    x: 81.793,
    y: 36.7114,
    width: 5.49105,
    height: 1.09821,
    rx: 0.549105,
    fill: "#9F95FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 394",
    x: 71.3594,
    y: 40.7417,
    width: 5.49105,
    height: 1.09821,
    rx: 0.549105,
    fill: "#9F95FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 396",
    x: 3.45703,
    y: 49.8257,
    width: 5.49105,
    height: 1.09821,
    rx: 0.549105,
    fill: "#9F95FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavenderSearch);
export default __webpack_public_path__ + "static/media/LavenderSearch.440ad5e13ca8cb382e743fe3a10fb65e.svg";
export { ForwardRef as ReactComponent };